export const PackageRoutes = {
  LIST: "/packages",
  DETAIL: "/packages/:id",
} as const;
